/** User-visible decline/cancel reason from backend. */
export function getDeclineReasonForDisplay(
  declineReason: string | null | undefined
): string {
  return declineReason?.trim() || ""
}
